/*eslint-disable import/default, import/namespace, import/no-named-as-default, import/no-named-as-default-member */
import React from 'react';
import Item from './StatsByServerItem';
import results from '../../data/results.json';

import usFlag from '../../images/usa@2x.png';
import deFlag from '../../images/ger@2x.png';
import brFlag from '../../images/bra@2x.png';
import auFlag from '../../images/aus@2x.png';
import jpFlag from '../../images/jpn@2x.png';

const StatsByServer = (props) => {
  const {stats} = props;
  const items = [];

  for (const key in stats) {
    const result = results[key];
    if (stats[key].locations && result && result.visible) {
      items.push({name: key, locations: stats[key].locations});
    }
  }

  return (
    <div className="results__stats-by-server">
      <table>
        <thead>
          <tr>
            <th className="is-label">Stats from Around the World</th>
            <th className="is-server"></th>
            <th className="is-server"></th>
            <th className="is-server"></th>
            <th className="is-server"></th>
            <th className="is-server"></th>
            <th className="is-server"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>
              <img src={usFlag} className="is-flag" />
              SF, USA
            </td>
            <td>
              <img src={usFlag} className="is-flag" />
              NY, USA
            </td>
            <td>
              <img src={deFlag} className="is-flag" />
              FR, GER
            </td>
            <td>
              <img src={brFlag} className="is-flag" />
              SP, BRA
            </td>
            <td>
              <img src={auFlag} className="is-flag" />
              SY, AUS
            </td>
            <td>
              <img src={jpFlag} className="is-flag" />
              TO, JPN
            </td>
          </tr>
          {items.map((stat, index) => (
            <Item stat={stat} key={index} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

StatsByServer.propTypes = {
  stats: React.PropTypes.object.isRequired
};

export default StatsByServer;



// WEBPACK FOOTER //
// ./src/components/results/StatsByServer.js